import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
// import {
//   LinkIcon
// } from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTdNetAssets extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func,
    mobile: PropTypes.bool
  }
  //
  constructor(props) {
    super(props)
    this.state = {
      formattedVal: format.money(
          props.shareclass.fund_net_assets,
          true,
          props.shareclass.currency,
          true
        )
    }
  }
  //
  render() {
    return <td
      styleName='col-right'
      onClick={
        this.props.mobile ?
          () => { } :
          this.props.clickShareclass(this.props.shareclass)
      }
    >
      {this.state.formattedVal}
    </td>
  }
}